import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './HostelerRegistrationForm.css'; // Import the CSS file
import { TextField } from '@mui/material';
const HostelerRegistrationForm = () => {
    const navigate = useNavigate(); // Hook for navigation

    const [formData, setFormData] = useState({
        fullName: '',
        gender: '',
        dob: '',
        mobileNumber: '',
        email: '',
        hostelName: '',
        roomType: '',
        checkinDate: '',
        emergencyContactName: '',
        emergencyContactNumber: '',
        identityProof: '',
        uploadDocument: null,
    });

    const handleChange = (e) => {
        const { name, value, type, files } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'file' ? files[0] : value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form Data:', formData);
        alert('Registration Successful!');
    };

    const handleReset = () => {
        if (window.confirm("Are you sure you want to reset the form?")) {
            setFormData({
                fullName: '',
                gender: '',
                dob: '',
                mobileNumber: '',
                email: '',
                hostelName: '',
                roomType: '',
                checkinDate: '',
                emergencyContactName: '',
                emergencyContactNumber: '',
                identityProof: '',
                uploadDocument: null,
            });
        }
    };

    const handleClose = () => {
        // Navigate to the home page
        navigate('/');
    };

    return (
        <div className="hosteler-registration-container">

            <div className="hosteler-registration-form">
                <button className="close-button" onClick={handleClose}>
                    &times;
                </button>
                <h2>Hosteler Registration Form</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Full Name</label>
                        <input
                            type="text"
                            name="fullName"
                            value={formData.fullName}
                            onChange={handleChange}
                            required
                        />
                    </div>
					<div className="form-group">
					 <TextField
            label="Booking ID"
            variant="outlined"
            required
            name="bookingId"
            value={formData.bookingId}
           
            className="form-input"
            
          />
		  </div>
                    <div className="form-group">
                        <label>Gender</label>
                        <select
                            name="gender"
                            value={formData.gender}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Select</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Other">Other</option>
                        </select>
                    </div>
                    <div className="form-group">
                        <label>Date of Birth</label>
                        <input
                            type="date"
                            name="dob"
                            value={formData.dob}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Mobile Number</label>
                        <input
                            type="tel"
                            name="mobileNumber"
                            value={formData.mobileNumber}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Email Address</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Room Type</label>
                        <select
                            name="roomType"
                            value={formData.roomType}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Select</option>
                            <option value="Single">Single</option>
                            <option value="Double">Double</option>
                            <option value="Dormitory">Dormitory</option>
                        </select>
                    </div>
                    <div className="form-group">
                        <label>Expected Check-in Date</label>
                        <input
                            type="date"
                            name="checkinDate"
                            value={formData.checkinDate}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Emergency Contact Name</label>
                        <input
                            type="text"
                            name="emergencyContactName"
                            value={formData.emergencyContactName}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Emergency Contact Mobile</label>
                        <input
                            type="tel"
                            name="emergencyContactNumber"
                            value={formData.emergencyContactNumber}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Identity Proof</label>
                        <select
                            name="identityProof"
                            value={formData.identityProof}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Select</option>
                            <option value="Aadhaar">Aadhaar</option>
                            <option value="Passport">Passport</option>
                            <option value="Driver's License">Driver's License</option>
                        </select>
                    </div>
                    <div className="form-group">
                        <label>Upload Document</label>
                        <input
                            type="file"
                            name="uploadDocument"
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-actions">
                        <button type="submit">Submit</button>
                        <button type="button" onClick={handleReset}>Reset</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default HostelerRegistrationForm;
